export default __webpack_public_path__ + "static/media/delete-grey.d9b66cc9.svg";